<template>
    <div class="b1">
        <div class="bg"></div>
        <div class="box">
            <div class="top">
                <div class="t_item">
                    <div>班级名称：</div>
                    <el-input placeholder="请输入内容" v-model="className"></el-input>
                </div>
                <div class="t_item">
                    <div>老师姓名：</div>
                    <el-input placeholder="请输入内容" v-model="zbrName"></el-input>
                </div>
                <div class="t_item">
                    <div>创建时间：</div>
                    <el-date-picker value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="dateVal" type="daterange" align="right" unlink-panels
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </div>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button type="primary" plain @click="reset">重置</el-button>
            </div>
            <div class="center">
                <div class="c_top">
                    <div class="ct_left">
                        我的班级
                        <span>总数：{{ total }}</span>
                    </div>
                </div>
                <div class="c_bottom">
                    <div class="cb_top">
                        <div>头像</div>
                        <div>班级名称</div>
                        <div>班级编号</div>
                        <!-- <div>状态</div> -->
                        <div>老师人数</div>
                        <div>学生人数</div>
                        <div>管理员</div>
                        <div>创建时间</div>
                    </div>
                    <div class="cb_list">
                        <div class="cb_bottom" v-for="(item, index) in list" :key="index" @click="$router.push({ path: '/classDetailManage', query: { id: item.id } })">
                            <div class="cbb_1">
                                <img :src="webImg + item.logo" />
                            </div>
                            <div class="cbb_2">{{ item.name }}</div>
                            <div class="cbb_3">{{ item.mihuaNo }}</div>
                            <div class="cbb_5">{{ item.teacherNum }}</div>
                            <div class="cbb_6">{{ item.studentNum }}</div>
                            <div class="cbb_7">{{ item.bzrName }}</div>
                            <div class="cbb_8">{{ item.createTime }}</div>
                        </div>
                        <el-empty description="暂无数据" v-if="list.length == 0"></el-empty>
                    </div>
                </div>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pageNum" :page-sizes="[10, 30, 50]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {
    schoolClassList
} from '@/apis/index'
export default {
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            pageNum: 1,
            pageSize: 10,
            total: 0,
            list: [],
            userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
            className: '',
            zbrName: '',
            dateVal: []
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageNum = 1
            this.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNum = val
            this.getList()
        },
        search() {
            setTimeout(() => {
                this.pageNum = 1
                this.getList()
            }, 500);
        },
        reset() {
            this.className = ''
            this.zbrName = ''
            this.dateVal = []
            this.pageNum = 1
            this.getList()
        },
        getList() {
            schoolClassList(this.pageNum,this.pageSize,{className: this.className, bzrName: this.zbrName, dateVal: this.dateVal}).then(res => {
                console.log(res, 'res');
                if (this.pageNum == 1) {
                    this.list = []
                }
                this.total = res.total
                this.list = res.data
            })
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep {
    .el-date-editor .el-range-separator {
        line-height: 27px !important;
    }
}

.b1 {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 1;

    .bg {
        width: 100%;
        height: 228px;
        background: linear-gradient(180deg, #F3F5FA 0%, #FFFFFF 100%);
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
    }
}

.box {
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding: 40px 0;

    .top {
        width: 100%;
        display: flex;
        align-items: center;

        .t_item {
            width: 300px;
            display: flex;
            align-items: center;
            margin-right: 40px;

            div {
                white-space: nowrap;
                font-weight: 400;
                font-size: 11px;
                color: #333333;
            }
        }
    }

    .center {
        width: 100%;
        height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        .c_top {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 40px 0;

            .ct_left {
                display: flex;
                align-items: center;
                font-weight: bold;
                font-size: 18px;
                color: #000000;

                span {
                    font-weight: 500;
                    font-size: 12px;
                    color: #999999;
                    margin-left: 18px;
                }
            }

            .ct_right {
                width: 92px;
                height: 32px;
                background: #399AFF;
                border-radius: 7px 7px 7px 7px;
                font-weight: 800;
                font-size: 14px;
                color: #FFFFFF;
                text-align: center;
                line-height: 32px;
                user-select: none;
                cursor: pointer;
            }
        }

        .c_bottom {
            width: 100%;
            height: 0;
            flex: 1;
            display: flex;
            flex-direction: column;
            margin-bottom: 20px;

            .cb_top {
                width: 100%;
                border-radius: 4px;
                background: #F4F6FB;
                display: flex;
                align-items: center;
                font-weight: bold;
                font-size: 12px;
                color: #657688;
                box-sizing: border-box;
                padding: 15px 12px;

                div:nth-child(1) {
                    width: 106px;
                }

                div:nth-child(2) {
                    width: 176px;
                }

                div:nth-child(3) {
                    width: 190px;
                }

                // div:nth-child(4) {
                //     width: 70px;
                // }

                div:nth-child(4) {
                    width: 143px;
                }

                div:nth-child(5) {
                    width: 143px;
                }

                div:nth-child(6) {
                    width: 143px;
                }

                div:nth-child(7) {
                    width: 158px;
                }

                div:nth-child(8) {
                    width: 143px;
                }
            }

            .cb_list {
                width: 100%;
                height: 0;
                flex: 1;
                overflow-y: scroll;

                .cb_bottom {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #F2F3F5;
                    // background-color: #fff;
                    box-sizing: border-box;
                    padding: 20px 12px;

                    .cbb_1 {
                        width: 106px;

                        img {
                            width: 44px;
                            height: 44px;
                            border-radius: 6px;
                        }
                    }

                    .cbb_2 {
                        width: 176px;
                    }

                    .cbb_3 {
                        width: 190px;
                    }

                    .cbb_4 {
                        width: 70px;

                        img {
                            width: 29px;
                            height: 18px;
                            cursor: pointer;
                        }
                    }

                    .cbb_5 {
                        width: 143px;
                    }

                    .cbb_6 {
                        width: 143px;
                    }

                    .cbb_7 {
                        width: 143px;
                    }

                    .cbb_8 {
                        width: 158px;
                    }

                    .cbb_9 {
                        width: 143px;
                        font-weight: 500;
                        font-size: 11px;
                        color: #CF1400;
                        cursor: pointer;
                        user-select: none;
                    }
                }
            }

        }
    }
}
</style>